module.exports = __webpack_public_path__ + "static/moonlitNightBeginning-bf6a7a460feef8792e424ae2c6b60d05.mp3";